import { useState } from 'react';
import { api } from '../api';
import type { User } from '../types';

interface Props {
  onLogin: (user: User) => void;
}

export function Login({ onLogin }: Props) {
  const [tab, setTab] = useState<'staff' | 'admin'>('staff');
  const [staffName, setStaffName] = useState('');
  const [staffPin, setStaffPin] = useState('');
  const [adminPass, setAdminPass] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit() {
    setErr('');
    setBusy(true);
    try {
      const res = tab === 'staff'
        ? await api.login({ mode: 'staff', username: staffName.trim(), password: staffPin })
        : await api.login({ mode: 'admin', password: adminPass });
      onLogin(res.user);
    } catch (e) {
      setErr(e instanceof Error ? e.message : String(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-screen">
      <div className="login-box">
        <div className="login-tabs">
          <button className={`tab-btn ${tab === 'staff' ? 'active' : ''}`} onClick={() => { setTab('staff'); setErr(''); }}>Staff Login</button>
          <button className={`tab-btn ${tab === 'admin' ? 'active' : ''}`} onClick={() => { setTab('admin'); setErr(''); }}>Management</button>
        </div>

        {tab === 'staff' ? (
          <>
            <div className="field-group">
              <label>Username</label>
              <input
                type="text"
                value={staffName}
                onChange={(e) => setStaffName(e.target.value)}
                placeholder="username"
                autoComplete="username"
                onKeyDown={(e) => e.key === 'Enter' && submit()}
              />
            </div>
            <div className="field-group">
              <label>Password</label>
              <input
                type="password"
                value={staffPin}
                onChange={(e) => setStaffPin(e.target.value)}
                placeholder="*****"
                autoComplete="current-password"
                onKeyDown={(e) => e.key === 'Enter' && submit()}
              />
            </div>
          </>
        ) : (
          <div className="field-group">
            <label>Admin Password</label>
            <input
              type="password"
              value={adminPass}
              onChange={(e) => setAdminPass(e.target.value)}
              placeholder="*******"
              onKeyDown={(e) => e.key === 'Enter' && submit()}
            />
          </div>
        )}

        <button className="login-btn" onClick={submit} disabled={busy}>
          {busy ? 'Signing in…' : 'Sign In'}
        </button>
        <div className="login-err">{err}</div>
      </div>
    </div>
  );
}
